import { isEmpty, get as lodashGet } from 'lodash';

export default {
  getXDestinationValue: (destinations) => {
    const bars = [];
    let distanceSum = 0;
    let prevData = null;
    destinations.forEach((destination) => {
      let bar = null;
      const { percentage, direction } = destination;
      const distance = !isEmpty(direction) ? direction.distance : 0;
      distanceSum += distance;

      const substract = ((100 - percentage) / 100) * distance;
      const x2Bar = percentage === 100 ? distanceSum : distanceSum - substract;

      if (percentage === 0) return false;

      if (isEmpty(bars)) {
        bar = {
          percentage,
          start: 0,
          end: x2Bar,
        };
        bars.push(bar);
      }

      if (!isEmpty(bars) && !isEmpty(prevData)) {
        const x1Bar = prevData.percentage === 100 ?
          prevData.end : distanceSum - distance;
        bar = {
          percentage,
          start: x1Bar,
          end: x2Bar,
        };
        bars.push(bar);
      }

      prevData = bar;
      return true;
    });

    return bars;
  },
  get: (object, key) => lodashGet(object, key) || '',
  inRange: (value, startValue, endValue) => value >= startValue && value <= endValue,
};



// WEBPACK FOOTER //
// ./src/views/pages/completion/helper.js